import { autoinject } from "aurelia-framework";
import { EventAggregator } from "aurelia-event-aggregator";
import moment from "moment";

import { IAddItemBehavior } from "../../../interfaces/form-builder/i-behavior";
import { FormButtonEvent } from "../form-input/form-button/form-button";
import { NoteDataManager } from "../note-data-manager";
import { FormValidationEnum } from "../../../enums/form-validation-enum";
import { ToastrService } from "../../../services/toastr-service";
import { IFormModel } from "../../../interfaces/form-builder/i-model-schema";

@autoinject
export class AddItemBehaviorHandler {
    private _ea: EventAggregator;
    private _toastrService: ToastrService;

    public constructor(ea: EventAggregator, toastrService: ToastrService) {
        this._ea = ea;
        this._toastrService = toastrService;
    }

    public handle(buttonBehavior: IAddItemBehavior, elementName: string, noteDataManager: NoteDataManager) {
        if (buttonBehavior.validations?.length > 0) {
            let addEncounterValidation = buttonBehavior.validations.find(
                (validation) => validation.validationType === FormValidationEnum.StartNewEncounter
            );
            let listGroupLengthValidation = buttonBehavior.validations.find(
                (validation) => validation.validationType === FormValidationEnum.ListGroupLength
            );
            let noteModel = noteDataManager.getNoteModel();
            let modifiedData = noteDataManager.getModifiedData();
            if (!!addEncounterValidation) {
                let firstCount: string[] = [];
                let secondCount: string[] = [];
                const countMatches = (data: IFormModel) => {
                    Object.keys(data).forEach((key) => {
                        let keySplit: string[] = key.split(".");
                        let index = Number(keySplit[1]);
                        if (
                            key.includes(addEncounterValidation.validationTargetFields[0]) &&
                            noteDataManager.getValue(key)
                        ) {
                            firstCount[index] = key;
                        }
                        if (
                            key.includes(addEncounterValidation.validationTargetFields[1]) &&
                            noteDataManager.getValue(key)
                        ) {
                            secondCount[index] = key;
                        }
                    });
                };
                countMatches(noteModel);
                countMatches(modifiedData);
                if (firstCount.length > secondCount.length) {
                    this._toastrService.error({
                        title: "Error - Start Encounter",
                        message: `${addEncounterValidation.validationMessage}`
                    });
                    return;
                }
            }
            if (!!listGroupLengthValidation) {
                let targetValues: any[] = [];
                let minTarget = listGroupLengthValidation.validationTargetFields[0];
                let maxTarget = listGroupLengthValidation.validationTargetFields[1];
                const addData = (data: IFormModel) => {
                    for (let key in data) {
                        if (key.includes(listGroupLengthValidation.validationTargetFields[0])) {
                            let keySplit = key.split(".");
                            let index = Number(keySplit[1]);
                            targetValues[index] = {
                                [minTarget]: noteDataManager.getValue(`${keySplit[0]}.${index}.${minTarget}`),
                                [maxTarget]: noteDataManager.getValue(`${keySplit[0]}.${index}.${maxTarget}`)
                            };
                        }
                    }
                };
                addData(noteModel);
                addData(modifiedData);
                if (!targetValues.length) {
                    this._toastrService.error({
                        title: "Error - Start Encounter",
                        message: `${listGroupLengthValidation.validationMessage}`
                    });
                    return;
                } else {
                    let assessment = targetValues.find((target) => {
                        // allow adding assessment if open encounter is there regardless of time range
                        if (!target[maxTarget]) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                    if (!assessment) {
                        this._toastrService.error({
                            title: "Error - Start Encounter",
                            message: `${listGroupLengthValidation.validationMessage}`
                        });
                        return;
                    }
                }
            }
        }
        this._ea.publish(FormButtonEvent.ListAddItem, buttonBehavior);
    }
}
